module.exports = __webpack_public_path__ + "static/media/kid-1280w.f3d256c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/kid-1280w.jpg
// module id = 19
// module chunks = 0